App.Modules = App.Modules || {};
App.Modules.slideBoxes = function () {


  (function($) {

  /**
  * Copyright 2012, Digital Fusion
  * Licensed under the MIT license.
  * http://teamdf.com/jquery-plugins/license/
  *
  * @author Sam Sehnert
  * @desc A small plugin that checks whether elements are within
  *     the user visible viewport of a web browser.
  *     only accounts for vertical position, not horizontal.
  */

    if ( jQuery('body').hasClass('page-template-page-about') ) {
    $.fn.visible = function(partial) {

      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };
    }

    })(jQuery);


  var slideBoxes = function(data) {
    if (jQuery('#about-slide-boxes').visible(true)) {
     
      jQuery('#about-slide-boxes .js-slide-box').each(function(i, el) {
        var el = jQuery(el);
        el.addClass("come-in"); 
      });
     
    } 
  };

  return {
    init: function() {
      return this;
  },
    events: function() {

      if ( jQuery('body').hasClass('page-template-page-about') ) {
        Events.bind(        
            "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
            document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
              "DOMMouseScroll", 'body.page-template-page-about'
        ).to(slideBoxes, {context: this});
      }

      return this;
    }
  };
}();
